import { Component, OnInit,ViewChild } from '@angular/core';
import { FormGroup, Validators, FormControl, FormBuilder } from '@angular/forms';
import { MdlTextFieldComponent  } from '../../lib/components';
import { LoginService  } from '../service';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.css']
})
export class ForgetPasswordComponent implements OnInit {

   @ViewChild('firstElement')  private inputElement: MdlTextFieldComponent;
     public loginForm: FormGroup;
    errorMessage: string;
  public processingLogin = false;
  public statusMessage = '';
  constructor(private fb: FormBuilder, private _loginService:LoginService) { }

  ngOnInit() {
     this.loginForm =  this.fb.group({
      'username' : ["", Validators.required]
    })
    this.inputElement.setFocus(); 
  }
  submitForm(){
      this.processingLogin = true;
      this.statusMessage = 'checking your credentials ...';
      this._loginService.forgetPassword(this.loginForm.value)
      .subscribe(user=>{
        this.processingLogin = false;
        this.statusMessage = 'Please check your mail';
      },error => this.errorMessage = <any>error);  
  }

}



// WEBPACK FOOTER //
// ./src/app/forget-password/forget-password.component.ts